import type { VerificationRequest } from 'matrix-js-sdk/src/crypto-api';

import { SetState } from 'utils/types';

export enum CrossSigningStatusEnum {
  VERIFIED = 'verified',
  NOT_VERIFIED = 'not_verified',
  UNKNOWN = 'unknown',
}

export type MatrixDeviceContextValue = {
  crossSigningStatus: CrossSigningStatusEnum;
  refreshCurrentDeviceStatus: () => Promise<void>;
  markDeviceVerified: () => void;
  setIsResettingKeys: (isResetting: boolean) => void;
  isResettingKeys: boolean;
  activeRequest: VerificationRequest | null;
  hasIncomingRequest: boolean;
  hasCompletedSelfVerification: boolean;
  requestVerification: () => Promise<VerificationRequest | null>;
  acceptRequest: () => Promise<void>;
  cancelRequest: () => void;
  devicesVerificationStatus: CrossSigningStatusEnum;
  checkForVerifiedDevices: () => Promise<void>;
  isLoadingVerifiedDevices: boolean;
  getLocationFromIp: (ip?: string) => Promise<string | null>;
  hasSecurityCode: boolean | null;
  refreshHasSecurityCode: () => Promise<boolean | null>;
  keyRestoreComplete: boolean;
  setKeyRestoreComplete: SetState<boolean>;
  /** True when another device reset keys and invalidated this session's account identity (BUG-023). */
  isAccountRemotelyInvalidated: boolean;
};
